import { create } from "zustand";

export type FilterTab = "all" | "image" | "video" | "audio" | "comments";

export interface ChatUIState {
    activeFilter: FilterTab;
    settingsPanelOpen: boolean;
    /** Любой attach-picker открыт (uploaded / generated). Нужен chat-wide
     * dropzone'у чтобы блокировать drop пока юзер выбирает из существующих
     * — иначе одновременный drop файла с компьютера и выбор из picker'а
     * приводит к non-deterministic поведению. */
    attachPickerOpen: boolean;
    /** Артефакт, на котором открыта единая галерея чата; null — закрыта. `id`
     *  служит якорем: по нему сервер отдаёт окно ленты ВОКРУГ этого объекта,
     *  поэтому предпросмотр открывается на своём месте в чате любой длины. */
    galleryTarget: GalleryTarget | null;

    setActiveFilter: (tab: FilterTab) => void;
    toggleSettingsPanel: () => void;
    setSettingsPanelOpen: (open: boolean) => void;
    setAttachPickerOpen: (open: boolean) => void;
    openGallery: (target: GalleryTarget) => void;
    closeGallery: () => void;
}

export interface GalleryTarget {
    id: string;
    url: string;
}

export const useChatUIStore = create<ChatUIState>((set) => ({
    activeFilter: "all",
    settingsPanelOpen: false,
    attachPickerOpen: false,
    galleryTarget: null,
    setActiveFilter: (activeFilter) => set({ activeFilter }),
    toggleSettingsPanel: () => set((s) => ({ settingsPanelOpen: !s.settingsPanelOpen })),
    setSettingsPanelOpen: (settingsPanelOpen) => set({ settingsPanelOpen }),
    setAttachPickerOpen: (attachPickerOpen) => set({ attachPickerOpen }),
    openGallery: (galleryTarget) => set({ galleryTarget }),
    closeGallery: () => set({ galleryTarget: null }),
}));
